<svg-icon-sprite
[src]="'assets/sprites/sprite.svg#ic_address'"
[width]="'22px'"
[classes]="'my-icon-class'"
></svg-icon-sprite> 